/**
 * Vendor imports
 */


// Lazysizes

import "lazysizes";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";

// Axios

declare global {
    interface Window {
        axios: any;
    }
}

window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

// disable default hash jump behaviour

import "@modules/disable-hash-jump";

/**
 * Vue.js
 */

// Register Vue

import Vue from "vue";

// Register Prototype Methods

Vue.prototype.svg = require("@modules/svg");

// Vue plugins

// @ts-ignore
import VueCompositionAPI from "@vue/composition-api";
Vue.use(VueCompositionAPI);

// Register Custom Components

const files = require.context("./", true, /\.vue$/i);
files.keys().map(key =>
    Vue.component(
        // @ts-ignore
        key
            .split("/")
            .pop()
            .split(".")[0],
        files(key).default
    )
);

/**
 * Create Vue Instances
 */

// Create Vue event bus

export const bus = new Vue();

// Create main Vue instance
import App from "./App.vue";

new App().$mount("#app");

//@ts-ignore
import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init({
    once: true
});
